// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__vRNgV","expand":"header_expand__log0D","collapse":"header_collapse__OK+r1","desktop":"header_desktop__c3Nkm","mobile":"header_mobile__-3AoW"};